import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useReducer } from 'react';
import { CustomNavigate } from '@/components/functional/Link/CustomNavigate';
import { CustomRoute } from '@/components/functional/Link/CustomRoute';
import { CustomRoutes } from '@/components/functional/Link/CustomRoutes';
import { RfpClientOneFileAllViewSkeleton } from '@/components/pages/rfp/client/RfpClientOneFileAllView';
import { useRfpClient } from '@/hooks/pages/rfp/useRfpClient';
import { RfpClientOneFileAll } from '@/pages/rfp/client/RfpClientOneFileAll';
import { RfpClientOneFileAllConfirm } from '@/pages/rfp/client/RfpClientOneFileAllConfirm';
import { initialState, reducer, } from '@/pages/rfp/client/RfpClientOneFileAllRoot/RfpClientOneFileAllRootReducer';
import { pagePath, getChildPath } from '@/utils/router/pagePath';
const rootPath = pagePath.project.client.fileRoot(':id');
const clientPath = pagePath.project.client;
export const RfpClientOneFileAllRoot = (props) => {
    const { profile } = props;
    // 案件詳細データ取得, ページ状態管理
    const { loading, offers, rfp } = useRfpClient();
    // 閲覧申請一覧、フォーム入力値のstate
    const [formState, formDispatch] = useReducer(reducer, initialState);
    // 全体ローディング表示
    if (loading && !rfp) {
        return _jsx(RfpClientOneFileAllViewSkeleton, {});
    }
    // リダイレクト: マイページ
    if (!rfp) {
        return _jsx(CustomNavigate, { to: pagePath.mypage.client.index() });
    }
    return (_jsxs(CustomRoutes, { children: [_jsx(CustomRoute, { element: _jsx(RfpClientOneFileAll, { formDispatch: formDispatch, formState: formState, offers: offers, profile: profile, rfp: rfp }), path: getChildPath(clientPath.fileAll(':id'), rootPath) }), _jsx(CustomRoute, { element: _jsx(RfpClientOneFileAllConfirm, { formDispatch: formDispatch, formState: formState, offers: offers, profile: profile, rfp: rfp }), path: getChildPath(clientPath.fileAllConfirm(':id'), rootPath) })] }));
};
